import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const TitleStyle: React.CSSProperties = {
    fontFamily: 'Segoe UI',
    fontSize: '1.6rem',
    fontWeight: 100,
    color: 'rgba(0,0,0,0.6)',
};

export const Title = styled('h1', TitleStyle);



// WEBPACK FOOTER //
// ./primitives/Title.tsx